import React from 'react';
import KickImage from 'Reuseables/KickImage';

import {
  Container,
  Row,
  Col,
} from 'reactstrap';

const BannerLoading = () => {

  return (
    <Container fluid className="page-container">
      <Row>
        <Col className="banner__loading">
          <div className="banner__loading_center">
            <h3 style={{ visibility: 'hidden' }}>Image</h3>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
export default BannerLoading;
